import { pushGoogleTag, pushFBEvent } from './common';
import { sendFirebaseEvent } from './firebase';

export const PLANS = {
  'gz-6-month-panther': {
    name: 'gz-6-month-panther',
    price: 71.76,
    periodPrice: 71.76,
    description: 'six months',
    productId: '6 months - $71.76',
    duration: '6 months',
  },

  'gz-1-day-test': {
    name: 'gz-1-day-test',
    price: 71.76,
    periodPrice: 71.76,
    description: 'one day',
    productId: '1 day test - $71.76',
    duration: '1 day',
  },

  'gz-3-month-fox': {
    name: 'gz-3-month-fox',
    price: 59.88,
    periodPrice: 59.88,
    description: 'three months',
    productId: '3 months - $59.88',
    duration: '3 months',
  },

  'gz-1-month-tiger': {
    name: 'gz-1-month-tiger',
    price: 39.96,
    periodPrice: 39.96,
    description: 'one month',
    productId: '1 month - $39.96',
    duration: '1 month',
  },

  'gz-1-week-cucumber': {
    name: 'gz-1-week-cucumber',
    price: 9.99,
    periodPrice: 9.99,
    description: 'one week',
    productId: '1 week - $9.99',
    duration: '1 week',
  },

  'gz-1-month-intro-franko': {
    name: 'gz-1-month-intro-franko',
    price: 9.99,
    periodPrice: 9.99,
    description: 'one week trial',
    productId: '1 month - $9.99',
    duration: '1 month',
  },

  'gz-1-month-tomato': {
    name: 'gz-1-month-tomato',
    price: 19.96,
    periodPrice: 19.96,
    description: 'one month',
    productId: '1 month - $19.96',
    duration: '1 month',
  },

  'gz-3-month-garlic': {
    name: 'gz-3-month-garlic',
    price: 35.88,
    periodPrice: 35.88,
    description: 'three months',
    productId: '3 months - $35.88',
    duration: '3 months',
  },

  'gz-3-months-intro-banana': {
    name: 'gz-3-months-intro-banana',
    price: 0.99,
    periodPrice: 0.99,
    description: 'three days trial',
    productId: '3 months - $0.99',
    duration: '3 months',
  },

  'gz-3-months-red-banana': {
    name: 'gz-3-months-red-banana',
    price: 39.99,
    periodPrice: 39.99,
    description: 'three months',
    productId: '3 months - $39.99',
    duration: '3 months',
  },

  'gz-1-month-intro-kobylanska': {
    name: 'gz-1-month-intro-kobylanska',
    price: 0.99,
    periodPrice: 0.99,
    description: 'three days trial',
    productId: '1 month - $0.99',
    duration: '1 month',
  },

  'gz-1-week-red-persik': {
    name: 'gz-1-week-red-persik',
    price: 11.99,
    periodPrice: 11.99,
    description: 'one week',
    productId: '1 week - $11.99',
    duration: '1 week',
  },

  'gz-1-month-intro-shevchenko': {
    name: 'gz-1-month-intro-shevchenko',
    price: 0.99,
    periodPrice: 0.99,
    description: 'one week trial',
    productId: '1 month - $0.99',
    duration: '1 month',
  },

  'gz-28-days-vasyl-stus': {
    name: 'gz-28-days-vasyl-stus',
    price: 0,
    periodPrice: 0,
    description: 'three days free trial',
    productId: '28 days - $0',
    duration: '28 days',
  },

  'gz-56-days-lesya-ukrainka': {
    name: 'gz-56-days-lesya-ukrainka',
    price: 47.92,
    periodPrice: 47.92,
    description: 'two months',
    productId: '56 days - $47.92',
    duration: '56 days',
  },

  'gz-1-month-intro-vynnychenko': {
    name: 'gz-1-month-intro-vynnychenko',
    price: 0.99,
    periodPrice: 0.99,
    description: 'one week trial',
    productId: '1 month - $0.99',
    duration: '1 month',
  },

  'gz-1-month-tychyna': {
    name: 'gz-1-month-tychyna',
    price: 11.97,
    periodPrice: 11.97,
    description: 'one month',
    productId: '1 month - $11.97',
    duration: '1 month',
  },

  'gz-3-month-kostenko': {
    name: 'gz-3-month-kostenko',
    price: 39.95,
    periodPrice: 39.95,
    description: 'three months',
    productId: '3 months - $39.95',
    duration: '3 months',
  },
  'gz-1-month-2999': {
    name: 'gz-1-month-2999',
    price: 29.99,
    periodPrice: 29.99,
    description: 'one month',
    productId: '1 month - $29.99',
    duration: '1 month',
  },
  'gz-monthly-free3d-2999': {
    name: 'gz-1-month-latam1',
    price: 29.99,
    periodPrice: 0,
    description: 'three days free trial',
    productId: '1 month - $29.99',
    duration: '1 month',
  },
  // upsell plans
  'gz-monthly-upsell-999': {
    name: 'gz-monthly-upsell-999',
    price: 9.99,
    periodPrice: 9.99,
    description: 'monthly upsell',
    productId: '1 month - upsell $9.99',
    duration: '1 month',
  },
  'gz-3month-upsell-999': {
    name: 'gz-3month-upsell-999',
    price: 9.99,
    periodPrice: 9.99,
    description: 'three months upsell',
    productId: '3 months - upsell $9.99',
    duration: '3 months',
  },
  'gz-6month-upsell-999': {
    name: 'gz-6month-upsell-999',
    price: 9.99,
    periodPrice: 9.99,
    description: 'six months upsell',
    productId: '6 months - upsell $9.99',
    duration: '6 months',
  },
};

const UPSELL_PRODUCT = {
  name: 'gz-monthly-driver-sos-skovoroda',
  price: 9.99,
  quantity: 1,
};

export const setMetrics = (
  plan,
  id,
  finalPrice,
  isUpsell = false,
  referer = '',
  eventId,
  gclid
) => {
  const price = finalPrice || PLANS[plan].periodPrice;
  const upsellPrice = UPSELL_PRODUCT.price;

  const items = isUpsell
    ? [
        {
          item_name: PLANS[plan].name,
          item_id: PLANS[plan].name,
          item_price: price,
          quantity: 1,
          item_coupon: '',
        },
        {
          item_name: UPSELL_PRODUCT.name,
          item_id: UPSELL_PRODUCT.name,
          item_price: upsellPrice,
          quantity: 1,
          item_coupon: '',
        },
      ]
    : [
        {
          item_name: PLANS[plan].name,
          item_id: PLANS[plan].name,
          item_price: price,
          quantity: 1,
          item_coupon: '',
        },
      ];

  const gaData = {
    transaction_id: id,
    affiliation: 'Onboarding Store',
    value: isUpsell ? upsellPrice : price,
    tax: 0,
    shipping: 0,
    currency: 'USD',
    coupon: '',
    gclid,
    referer,
    items,
  };

  const setFbData = (type) => ({
    value: type === 'upsell' ? upsellPrice : price,
    currency: 'USD',
    content_type: type,
    content_name: referer,
    subscription_sid: id,
  });

  const fbData = setFbData(
    plan === 'gz-1-month-intro-vynnychenko' ? 'trial' : 'paid_subscription'
  );
  const upsellFbData = setFbData('upsell');

  pushFBEvent(fbData, eventId);
  sendFirebaseEvent('purchase', gaData);
  pushGoogleTag('purchase', gaData);
  if (isUpsell) {
    pushFBEvent(upsellFbData, `${eventId}_upsell`);
  }
};
